<template>
  <div class='slide slide--paired-comparison'>
    <div class='slide_label body-four-light'>
      {{ activity.label || $t('paired_comparison') }}
    </div>

    <h2 class='slide_headline h-two-light'>
      {{ activity.headline }}
    </h2>

    <div
      v-if='activity.subheadline'
      class='slide_subheadline body-one-light'
    >
      {{ activity.subheadline }}
    </div>

    <button
      class='slide_cta button-one-light'
      @click.prevent='take()'
    >
      {{ activity.cta }}
    </button>
  </div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  methods: {
    take() {
      this.toggleActivityOverlay()

      if (typeof (dataLayer) !== 'undefined') {
        const event = {
          event: 'startThisOrThat',
          pageCategory: 'thisorthat'
        }
        dataLayer.push(event)
      }
    }
  }
}
</script>
